var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8DCBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0381 23.926C36.0394 22.4935 33.1186 21.3333 29.5197 21.3333C25.9208 21.3333 23.0026 22.4948 23 23.926M23 23.926C23 25.3584 25.9182 26.5186 29.5197 26.5186C33.1212 26.5186 36.0394 25.3584 36.0394 23.926L36.0394 33.9852M23 23.926V39.4816C23.0013 40.914 25.9195 42.0742 29.5197 42.0742C31.2657 42.0742 32.8421 41.7981 34.0118 41.3534M23.0013 29.1112C23.0013 30.5436 25.9195 31.7038 29.521 31.7038C33.1225 31.7038 36.0407 30.5436 36.0407 29.1112M34.09 36.1437C32.9139 36.6039 31.3009 36.8891 29.5197 36.8891C25.9195 36.8891 23.0013 35.7289 23.0013 34.2965M43.4484 34.7087C45.7394 36.9864 45.7394 40.6808 43.4484 42.9585C41.1574 45.2361 37.4411 45.2361 35.1501 42.9585C32.8591 40.6808 32.8591 36.9864 35.1501 34.7087C37.4411 32.4311 41.1574 32.4311 43.4484 34.7087Z",
    stroke: "#896620",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F2ECDE",
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPlan);
export default __webpack_public_path__ + "static/media/paymentPlan.19e73288dddbbb60f9351b98928adeae.svg";
export { ForwardRef as ReactComponent };